<template>
        <div style="height:600px">
            <div>
                <el-table
                        :data="$parentInfo.createLimit.headTeacherLimits"
                          style="width: 100%"
                          :height="500"
                          size="middle">
                    <el-table-column prop="name" label="班主任" min-width="5%"></el-table-column>
                    <el-table-column  label="开始日期" min-width="10%">
                        <template slot-scope="scope">
                            <el-date-picker
                                    v-model="scope.row.start_date"
                                    size="small"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="日期"
                                    style="width: 150px">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column label="结束日期" min-width="10%">
                        <template slot-scope="scope">
                            <el-date-picker
                                    v-model="scope.row.end_date"
                                    size="small"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="日期"
                                    style="width: 150px">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column label="额度" min-width="10%">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.money" placeholder="请输入金额" size="small" style="width: 100px"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="10%">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleAll(scope.row)">适用全部</el-button>
                            <el-button @click="handleCreate()" :loading="$parentInfo.createLimit.button_loading">保存</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="text-right">
                <el-button @click="handleCreate()" :loading="$parentInfo.createLimit.button_loading">保存</el-button>
            </div>
        </div>
</template>

<script>
    export default {
        name: "create_limit",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleIndexLimit();
        },
        methods: {
            handleIndexLimit() {
                this.$wApi.send(this.$parentInfo.path, 'get_headTeachers', {});
            },
            handleCreate() {
                this.$parentInfo.createLimit.button_loading = true;
                this.$parentInfo.loading = true;
                this.$wApi.send(this.$parentInfo.path, 'store_headTeacherLimits', {'headTeacherLimits':this.$parentInfo.createLimit.headTeacherLimits});
            },
            handleAll(val) {
                var vm = this;
                vm.$parentInfo.createLimit.headTeacherLimits.forEach(function (item) {
                    item.start_date = val.start_date;
                    item.end_date = val.end_date;
                    item.money = val.money;
                });
            }
        }
    }
</script>

<style scoped>
    .card-body{
        height: calc(100vh - 125px);
    }
    .card-footer{
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>